import MFlag from './MFlag.vue';

MFlag.install = (app) => {
  app.component('MFlag', MFlag);
};

export { MFlag };
